import React from 'react';
import PropTypes from 'prop-types';

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  EmailIcon,
} from 'react-share';

const Share = ({ url, description = '', title, hashtag, campaignOptions }) => {
  let queryString = '';
  if (campaignOptions) {
    queryString = `?utm_source=${campaignOptions.source}&utm_medium=${campaignOptions.medium}&utm_campaign=${campaignOptions.campaign}`;
  }

  return (
    <div className="share-buttons">
      <FacebookShareButton
        className="inline-block mr-1"
        url={url.concat(queryString)}
        hashtag={`#${hashtag.shift()}`}
        quote={title}
      >
        <FacebookIcon round size={40} />
      </FacebookShareButton>
      <TwitterShareButton
        className="inline-block mr-1"
        url={url.concat(queryString)}
        title={title}
        hashtags={hashtag}
      >
        <TwitterIcon round size={40} />
      </TwitterShareButton>
      <LinkedinShareButton
        className="inline-block mr-1"
        url={url.concat(queryString)}
        description={description}
        title={title}
      >
        <LinkedinIcon round size={40} />
      </LinkedinShareButton>
      <EmailShareButton
        url={url.concat(queryString)}
        className="inline-block mr-1"
        subject={title}
        body={`${description}\n\n${url.concat(queryString)}`}
      >
        <EmailIcon round size={40} />
      </EmailShareButton>
    </div>
  );
};

Share.propTypes = {
  url: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  hashtag: PropTypes.arrayOf(PropTypes.string.isRequired),
  campaignOptions: PropTypes.shape({
    source: PropTypes.string,
    medium: PropTypes.string,
    campaign: PropTypes.string,
  }),
};

Share.defaultProps = {
  hashtag: ['W6E', 'weremoteEU'],
  campaignOptions: null,
};

export default Share;
